export default "__VITE_ASSET__BVlmyT5C__"